
import React from 'react';
import { Box, Typography, Button, makeStyles } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import TopBar from 'src/layouts/MainLayout/TopBar';
import bgImage from '../assets/images/landing-page-mobile.png';
import clockIcon from '../assets/images/clockIcon.png';
import secureIcon from '../assets/images/privacyIcon.png';
import updateIcon from '../assets/images/notificationIcon.png';

const NEW_APP_URL = process.env.REACT_APP_NEW_APP_URL || 'https://new-app.example.com';

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 430,
        margin: '0 auto',
        padding: '4.5rem 1rem 2rem 1rem',
        background: '#fff',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontFamily: 'IBM Plex Sans, Arial, sans-serif',
        position: 'relative',
    },
    headline: {
        fontFamily: 'IBM Plex Sans, Arial, sans-serif',
        fontWeight: 700,
        fontSize: '2.2rem',
        margin: 0,
        textAlign: 'left',
        width: '100%',
        color: '#111',
    },
    redText: {
        color: '#D7263D',
    },
    tiresImg: {
        width: '100%',
        objectFit: 'cover',
        marginTop: '1.5rem',
        marginBottom: '1.5rem',
    },
    subText: {
        color: '#6B7280',
        fontSize: '1.1rem',
        textAlign: 'left',
        width: '100%',
        marginBottom: '2rem',
    },
    claimButton: {
        width: '100%',
        background: '#D7263D',
        color: '#fff',
        border: 'none',
        borderRadius: 12,
        padding: '1rem 0',
        fontSize: '1.1rem',
        fontWeight: 600,
        boxShadow: '0 4px 16px rgba(215,38,61,0.15)',
        marginBottom: '2rem',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        textTransform: 'none',
        transition: 'box-shadow 0.2s',
        '&:hover': {
            boxShadow: '0 8px 24px rgba(215,38,61,0.22)',
            background: '#c51e2c',
        },
    },
    features: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '1.5rem',
        marginBottom: '2rem',
    },
    featureGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    featureIconWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        borderRadius: '50%',
        padding: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        marginRight: 4,
        border: '2px solid #DC2626',
        width: 28.51,
        height: 28.51,
    },
    featureIcon: {
        width: 17.11,
        height: 17.11,
        display: 'block',
    },
    featureText: {
        color: '#374151',
        fontSize: '1rem',
        fontFamily: 'IBM Plex Sans, Arial, sans-serif',
    },
    footer: {
        marginTop: 'auto',
        marginBottom: 8,
    },
}));

const LandingMobileView = () => {
    const classes = useStyles();
    const handleRedirect = () => {
        window.location.href = NEW_APP_URL;
    };

    return (
        <Box className={classes.root}>
            <TopBar />
            <Typography variant="h1" className={classes.headline}>
                Experience a<br />seamless<br />
                <Box component="span" className={classes.redText}>Claims Journey</Box>
            </Typography>
            <img
                src={bgImage}
                alt="Tires"
                className={classes.tiresImg}
            />
            <Typography className={classes.subText}>
                File, track, and manage your claim with confidence. Real-time updates and 24/7 support at your fingertips.
            </Typography>
            <Button
                onClick={handleRedirect}
                className={classes.claimButton}
                endIcon={<ArrowForwardIcon style={{ fontSize: '1.3rem' }} />}
            >
                Start Or Access Your Claim
            </Button>
            <Box className={classes.features}>
                <Box className={classes.featureGroup}>
                    <Box className={classes.featureIconWrapper}>
                        <img src={clockIcon} alt="24/7 Access" className={classes.featureIcon} />
                    </Box>
                    <Box component="span" className={classes.featureText}>24/7 Access</Box>
                </Box>
                <Box className={classes.featureGroup}>
                    <Box className={classes.featureIconWrapper}>
                        <img src={secureIcon} alt="Secure & Private" className={classes.featureIcon} />
                    </Box>
                    <Box component="span" className={classes.featureText}>Secure & Private</Box>
                </Box>
                <Box className={classes.featureGroup}>
                    <Box className={classes.featureIconWrapper}>
                        <img src={updateIcon} alt="Instant Updates" className={classes.featureIcon} />
                    </Box>
                    <Box component="span" className={classes.featureText}>Instant Updates</Box>
                </Box>
            </Box>           
        </Box>
    );
};

export default LandingMobileView;
